import mapRelationships from '@/utils/mapRelationships'
export default function mapIncluded(state, object, type, typePlural = type + 's') {
  return mapRelationships(state, object?.relationships[typePlural].data)
}
